import { Paper, styled } from '@mui/material';
export const ToastContainer = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'start',
    width: '100%',
    maxWidth: 452,
    padding: theme.spacing(1.5, 3),
    boxShadow: theme.shadows[4],
}));
export const IconContainer = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(-0.25),
    marginRight: theme.spacing(-1.5),
}));
